export default [
  {
    itemType: 'group',
    colCount: 1,
    items: [
      {
        dataField: 'tabela_nome',
        label: { text: 'Descrição' },
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório'
        }]
      },
      {
        template: 'gridModalidade'
      }
    ]
  }
]
